import { useCallback } from 'react'

import { FileItem } from '@inno-sdks/files'
import { useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

import { getFileItemQueryOptions } from '../../api/hooks/useGetFileItem'
import { useDownloaderStore } from '../../store/downloadStore'
import { downloadFile } from '../../utils'
import { useDownloadFileBase } from './useDownloadFileBase'

export const useDownloadFile = () => {
  const queryClient = useQueryClient()
  const downloadFileBase = useDownloadFileBase()

  return useCallback(async (itemId: number) => {
    const item = await queryClient.fetchQuery(
      getFileItemQueryOptions<FileItem>(itemId)
    )

    if (!item) return

    const abortController = new AbortController()

    const {
      addItem,
      markCompleted,
      markFailed,
      cancelDownload,
      downloadProgress
    } = useDownloaderStore.getState()

    try {
      addItem({
        id: item.id,
        label: item.name,
        progress: 0,
        abortController,
        item,
        status: 'pending',
        onCancel: () => cancelDownload(item.id)
      })

      const downloadedFile = await downloadFileBase(itemId, {
        onProgress: progress => downloadProgress(item.id, progress),
        abortController
      })

      if (!downloadedFile) {
        return
      }

      downloadFile(downloadedFile, downloadedFile.name)
      markCompleted(item.id)
    } catch (error) {
      if (!axios.isCancel(error)) {
        markFailed(item.id)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
